import * as React from 'react';
import './PageComponent.scss';

interface IProps {
    onClick: any;
    title?: string;
}

 const NestedBackButton = (props : IProps) => {
    
    return <button 
                className="btn-clear nested-back-button" 
                onClick={ props.onClick }>
                    <i className="la la-arrow-circle-o-left"/>
                    { props.title }
            </button>;
};

NestedBackButton.defaultProps = {
    title: 'Back to List'
};

export { NestedBackButton };
